import { Controller } from 'stimulus'
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = ['record', 'downloadFile']

  triggerShare() {
    const url = this.downloadFileTarget.href
    navigator.clipboard.writeText(url).then(function() {
      alert('Your share link has been copied to clipboard.')
    }, function(err) {
      alert('We encountered an error: ' + err)
    })
  }

  triggerEdit() {
    console.log('You clicked edit')
  }
}
